import { Box, Typography } from "@mui/material"
import { Link } from "react-router-dom"

const ElibaryLinkCard = ({ link, label, icon }) => {
  return (
    <Link to={link}>
      <Box className="e-libary-list-link-card-box">
        {icon} <Typography>{label}</Typography>
      </Box>
    </Link>)
}

export default ElibaryLinkCard
